<template>
    <errorlog url="/platformSDBao/health/sdbao/errorlog"/>
</template>

<script>
    import errorlog from '@/components/errorlog';
    export default {
        name: "errorlog_platformSDBao",
        components:{
            errorlog
        }
    };
</script>

<style scoped>

</style>